/* istanbul ignore file */
export const BASE_URL =
  (typeof import.meta !== "undefined" && (import.meta as any)?.env?.VITE_API_BASE_URL) ??
  process.env.VITE_API_BASE_URL ??
  "https://pcs-dev.fujairahport.ae";

export const NOTIF_SERVICE_SEGMENT = "bff-notification";
